import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Loadable from 'react-loading-overlay'

@observer(['companies', 'globals', 'quickbooks', 'quotes'])

export default class PackingSlip extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loadableState: true
    }

    this.props.quickbooks.getQuickbooksCompanyItems((qbItemArray) => {
      this.props.quickbooks.getQuickbooksTerms((qbTermsArray) => {
        this.props.quickbooks.getQuickbooksTaxRates((qbTaxRatesArray) => {
          this.loadQuoteDetails(this.props.params.quoteId, qbItemArray, qbTermsArray, qbTaxRatesArray)
        })
      })
    })
  }

  loadQuoteDetails(quoteId, qbItemArray, qbTermsArray, qbTaxRatesArray) {
    this.props.quotes.loadQuote(quoteId, qbItemArray, qbTermsArray, qbTaxRatesArray, (data) => {
      console.log(this.props.quotes.quoteDetail)
      let row = {
        id: data.companyId
      }
      this.props.companies.loadCompanyDetails(row)
    })

    this.props.quotes.loadQuoteHardware(quoteId, qbItemArray)

    this.setState({
      loadableState: false
    })
  }

  formatTaxExempt(cell, row) {
    return (cell === 1 ? 'Yes' : 'No')
  }

  render() {

    let hardwareList = ''

    if (this.props.quotes.quoteHardware.length > 0) {
      hardwareList = this.props.quotes.quoteHardware.map((hw) => {
        return (<tr> 
          <td>{ hw.hardwareName }</td>
          <td colspan={2}>{ hw.hardwareDescription }</td>
          <td>{ hw.quantity }</td>
        </tr>)
      })
    }

    return (
      <div className="right_col" role="main">
        <div className="">
          <Loadable active={ this.state.loadableState } spinner text='Processing your request...'>
            <div style={{ height: 'inherit' }} >
              <table style={{ width: '90%', margin: '5%'}}>
                <tbody>
                  <tr>
                    <td colSpan={ 4 } style={{ textAlign: 'center' }}>
                      <img src="/images/logo-white.png" /><br />
                      <small>30724 Benton Road Suite C 302-413<br />Winchester, CA 92596</small>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={ 4 } style={{ paddingTop: '30px', fontSize: '150%', textAlign: 'center' }}><b>{ 'Packing Slip' }</b></td>
                  </tr>
                  <tr>
                    <td style={{ paddingTop: '30px' }}>Date: { this.props.quotes.quoteDetail.formattedQuoteDate }</td>
                    <td style={{ paddingTop: '30px' }}>Rep: { this.props.quotes.quoteDetail.userFullName }</td>
                    <td style={{ paddingTop: '30px' }}>Contract Term: { this.props.quotes.quoteDetail.contractTermName }</td>
                    <td style={{ paddingTop: '30px' }}>Payment Term: { this.props.quotes.quoteDetail.paymentTermName }</td>
                  </tr>
                  <tr>
                    <td colSpan={ 2 } style={{ paddingTop: '30px' }}><b>Bill To</b></td>
                    <td colSpan={ 2 } style={{ paddingTop: '30px' }}><b>Ship To</b></td>
                  </tr>
                  <tr>
                    <td style={{ paddingTop: '15px' }}><small><b>Company</b></small></td>
                    <td style={{ paddingTop: '15px' }}><small>{ this.props.companies.details.name }</small></td>
                    <td style={{ paddingTop: '15px' }}><small><b>Company</b></small></td>
                    <td style={{ paddingTop: '15px' }}><small>{ this.props.companies.details.name }</small></td>
                  </tr>
                  <tr>
                    <td><small><b>Name</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.billingAddressName }</small></td>
                    <td><small><b>Name</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.shippingAddressName }</small></td>
                  </tr>
                  <tr>
                    <td><small><b>Address</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.billingAddressAddress }</small></td>
                    <td><small><b>Address</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.shippingAddressAddress }</small></td>
                  </tr>
                  <tr>
                    <td><small><b>City</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.billingAddressCity }</small></td>
                    <td><small><b>City</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.shippingAddressCity }</small></td>
                  </tr>
                  <tr>
                    <td><small><b>State</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.billingAddressState }</small></td>
                    <td><small><b>State</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.shippingAddressState }</small></td>
                  </tr>
                  <tr>
                    <td><small><b>Zip</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.billingAddressZipCode }</small></td>
                    <td><small><b>Zip</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.shippingAddressZipCode }</small></td>
                  </tr>
                  <tr>
                    <td><small><b>Country</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.billingAddressCountry }</small></td>
                    <td><small><b>Country</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.shippingAddressCountry }</small></td>
                  </tr>
                  <tr>
                    <td style={{ paddingTop: '30px' }}></td>
                  </tr>
                  <tr>
                    <td colSpan={ 4 } style={{ fontSize: '125%', textAlign: 'center', backgroundColor: '#efefef' }}><b>Items</b></td>
                  </tr>
                  <tr>
                    <td colSpan={ 4 }>
                      <table style={{ width: '100%' }}>
                        <tbody>
                          <tr>
                            <td><b>Item</b></td>
                            <td><b>Description</b></td>
                            <td><b>QTY</b></td>
                          </tr>
                          { hardwareList }
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="pagebreak-print">
              <table style={{ width: '90%', margin: '5%' }}>
                <tbody>
                  <tr>
                    <td style={{ fontSize: '125%', textAlign: 'center', backgroundColor: '#efefef' }} colSpan={ 3 }><b>Serial Numbers</b></td>
                  </tr>
                  <tr>
                    <td colSpan={ 3 } style={{ paddingTop: '25px', whiteSpace: 'pre-wrap' }}>{ this.props.quotes.quoteDetail.serialNumbers }</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Loadable>
          <div className="clearfix"></div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/packingslip.js